
  var style = require("icon-maker-loader/.tmp/28e27980-db16-4011-8a4d-a9e26dfc90be/icon-maker.js");
  var mainClass = style["icon-maker"];
  if (mainClass) {
    module.exports = mainClass + " " + style["icon-maker-remove"];
  } else {
    module.exports = "icon-maker icon-maker-remove";
  }
  


//////////////////
// WEBPACK FOOTER
// ./src/icons/remove.svg
// module id = 549
// module chunks = 5